module.exports = __webpack_public_path__ + "img/img4.a0bc7a2b.png";